<template>
  <div class="wrapper">
    
      <div class="section section-signup page-header header-filter" :style="headerStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-33 md-medium-size-40 md-small-size-50 md-xsmall-size-70 mx-auto text-center"
            >
             <div>
            <md-button
              class=" md-danger md-round btnA"
              color="red"
              href="#/basic"
              >Retour</md-button
            ></div>
            <md-card >
              <md-card-header
                style="background: linear-gradient(80deg,#f95050,#1818fa);"
              >
                <h2>
                  Importation des fichiers
                </h2>
              </md-card-header>

              <md-card-content>
                <Alert
                  v-if="showAlert.show"
                  :text="showAlert.msg"
                  :theme="showAlert.theme"
                />

                <div
                  class="col-sm-7"
                  style="background-color:#e6fffa; padding:1%; border-radius:1%"
                >
                  <h3>importer les utilisateurs</h3>
                  <form id="uploadSingleFileForm" @submit="uploadExcel">
                    <div class="form-group" id="idusers">
                      <label class="control-label" for="uploadfile"
                        >Choisir un fichier:</label
                      >
                      <br />
                      <input
                        @change="onFileChange"
                        type="file"
                        class="form-control"
                        placeholder="Choose a upload file"
                        name="file"
                        required
                      />
                    </div>
                    <br />
                    <button
                      type="submit"
                      class="btn btn-danger"
                      id="btnUploadSingleFileSubmit"
                    >
                      Submit
                    </button>
                  </form>
                </div>
                <br />
                <div
                  class="col-sm-7"
                  style="background-color:#e6fffa; padding:1%; border-radius:1%"
                >
                  <h3>importer les antennes</h3>
                  <form id="uploadSingleFileForm" @submit="uploadAntenne">
                    <div class="form-group" id="idusers">
                      <label class="control-label" for="uploadfile"
                        >Choisir un Fichier:</label
                      >
                      <br />
                      <input
                        @change="changeAntenne"
                        type="file"
                        class="form-control"
                        placeholder="Choose a upload file"
                        name="file"
                        required
                      />
                    </div>
                    <br />
                    <button
                      type="submit"
                      class="btn btn-danger"
                      id="btnUploadSingleFileSubmit"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              </md-card-content>
            </md-card>
            <div id="response" style="display:none" @submit="sucessFile"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import serviceUtilisateur from "../Services/serviceUtilisateur";
import axios from "../http-common";
import Alert from "./components/Alert";
import { alertTypes } from "../utils/constant";

export default {
  bodyClass: "login-page",
  //bodyClass: "download-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/volunters.webp"),
    },
  },
  components: {
    Alert,
  },
  data() {
    return {
      excel: null,
      excelAntenne: null,
      showAlert: {
        msg: "",
        show: false,
        theme: "success",
      },
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
  methods: {
    uploadExcel(event) {
      event.preventDefault();
      const data = new FormData();
      data.append("fileU", this.excel);
      axios
        .post("/upload/users", data)
        .then(() => {
          this.showAlert.show = true;
          this.showAlert.theme = alertTypes.success;
          this.showAlert.msg =
            "Fichier uploader avec succès .....";
        })
        .catch((error) => {
         // console.error(error.response);

          this.showAlert.show = true;
          this.showAlert.theme = alertTypes.danger;
          this.showAlert.msg =
            "Erreur lors de l'envoie des données .... meme sa tu te debrouille";
        });
      //console.log("encours d'envoi des données des utilisateurs");
    },
    onFileChange(evt) {
      this.excel = evt.target.files[0];
    },
    sucessFile(response) {
     // console.log("reponse success", response);
    },
    uploadAntenne(e) {
      e.preventDefault();
      const data = new FormData();
      data.append("file", this.excelAntenne);
      axios
        .post("/upload", data)
         .then(() => {
          this.showAlert.show = true;
          this.showAlert.theme = alertTypes.success;
          this.showAlert.msg =
            "Fichier uploader avec succès .....";
        })
        .catch((error)
          //=> console.log(error.response)
        );
      //console.log("encours d'envoi des données des antennes");
    },
    changeAntenne(e) {
      this.excelAntenne = e.target.files[0];
    },
  },
};
</script>

<style lang="css">
#idusers {
  background-color: white;
}
</style>
